import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "全部番剧", to: "/list" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(e.target as Node)) {
        setSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = search.trim();
    navigate(kw ? `/list?q=${encodeURIComponent(kw)}` : "/list");
    setSearchOpen(false);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-800 bg-background-950/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="container-site flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
            <i className="ri-movie-2-line text-lg" />
          </span>
          <span className="font-heading text-xl tracking-wide text-foreground-50">
            奶水动漫<span className="text-primary-400">.</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                location.pathname === l.to
                  ? "bg-background-800/70 text-primary-400"
                  : "text-foreground-200 hover:bg-background-800/40 hover:text-foreground-50"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <div className="relative ml-1">
            <button
              onClick={() => setSearchOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-200 transition-colors hover:bg-background-800/50 hover:text-primary-400"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </button>
            {searchOpen && (
              <form
                onSubmit={submitSearch}
                className="absolute right-0 top-12 w-72 overflow-hidden rounded-xl border border-background-700 bg-background-900 p-2 shadow-glow"
              >
                <div className="flex items-center gap-2 rounded-md bg-background-800 px-3">
                  <i className="ri-search-line text-foreground-400" />
                  <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="搜索想看的番剧…"
                    className="w-full bg-transparent py-2 text-sm text-foreground-100 outline-none placeholder:text-foreground-500"
                  />
                </div>
              </form>
            )}
          </div>
        </div>

        <button
          onClick={() => setMobileOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-100 md:hidden"
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="border-t border-background-800 bg-background-950/95 backdrop-blur-md md:hidden">
          <div className="container-site flex flex-col gap-1 py-3">
            <form onSubmit={submitSearch} className="mb-2 flex items-center gap-2 rounded-md bg-background-800 px-3">
              <i className="ri-search-line text-foreground-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="搜索想看的番剧…"
                className="w-full bg-transparent py-2.5 text-sm text-foreground-100 outline-none placeholder:text-foreground-500"
              />
            </form>
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-100 transition-colors hover:bg-background-800/50"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}